import type { ReactElement } from "react";
import { Outlet } from "react-router-dom";
import { FilterPanelProvider } from "./pages/browse/contexts/FilterPanelContext";
import { Header } from "./shared/components/Header";
import { KeyboardNavigationIndicator } from "./shared/components/KeyboardNavigationIndicator";

export function AppShell(): ReactElement {
  return (
    <FilterPanelProvider>
      <Header />
      <main>
        <Outlet />
      </main>
      <KeyboardNavigationIndicator />
    </FilterPanelProvider>
  );
}
